<template>
  <svg :width="`${width}px`" :height="`${height}px`">
    <path d="m16.4695,22.23618l-14.65185,0l0,-20.56184l14.6518,0l0,5.09679l1.56197,-1.56202l0,-4.31577c0.00005,-0.43129 -0.34969,-0.78099 -0.78094,-0.78099l-16.21382,0c-0.43134,0 -0.78113,0.34969 -0.78113,0.78099l0,22.12391c0,0.43129 0.34974,0.78099 0.78113,0.78099l16.21382,0c0.43124,0 0.78099,-0.34969 0.78099,-0.78099l0,-8.59422l-1.56197,1.56202l0,6.25112l0,0.00001z m-2.03,-18.69l-10.04671,0c-0.32942,0 -0.59675,0.26732 -0.59675,0.59685c0,0.32947 0.26732,0.5968 0.59675,0.5968l10.04666,0c0.32952,0 0.5968,-0.26732 0.5968,-0.5968c0.00005,-0.32952 -0.26727,-0.59685 -0.59675,-0.59685z m0.62,3.78c0,-0.32947 -0.26732,-0.59685 -0.5968,-0.59685l-10.04671,0c-0.32942,0 -0.59675,0.26737 -0.59675,0.59685c0,0.32952 0.26732,0.59685 0.59675,0.59685l10.04666,0c0.32952,0 0.59685,-0.26727 0.59685,-0.59685z m-1.43,2.58l-9.20704,0c-0.32942,0 -0.59675,0.26737 -0.59675,0.59685c0,0.32952 0.26732,0.5968 0.59675,0.5968l8.01335,0l1.1937,-1.19365l-0.00001,0z m-3.4,3.96c0.08078,-0.27045 0.19622,-0.52959 0.33684,-0.77362l-6.20533,0c-0.32942,0 -0.59675,0.26732 -0.59675,0.59685c0,0.32947 0.26732,0.59685 0.59675,0.59685l5.74337,0l0.12512,-0.42007l0,-0.00001z m-5.75,2.41c-0.32942,0 -0.59675,0.26732 -0.59675,0.59685c0,0.32942 0.26732,0.5968 0.59675,0.5968l5.24252,0c-0.15468,-0.37531 -0.19468,-0.78994 -0.08545,-1.19365l-5.15706,0l-0.00001,0z m18.8,-11.65c-0.31272,-0.31286 -0.73674,-0.48844 -1.17848,-0.48844c-0.44174,0 -0.86566,0.17557 -1.17805,0.48805l-8.82977,8.83001c-0.24094,0.24085 -0.41767,0.53734 -0.51525,0.86374l-0.70362,2.35861c-0.02994,0.09985 -0.00274,0.20787 0.0711,0.28172c0.05402,0.05407 0.12632,0.08314 0.20046,0.08314c0.02687,0 0.0544,-0.00385 0.08126,-0.01199l2.35846,-0.70372c0.32649,-0.09753 0.62299,-0.27435 0.86379,-0.5152l8.83006,-8.82967c0.31238,-0.31243 0.48805,-0.73631 0.48805,-1.1781c0,-0.44188 -0.17562,-0.86576 -0.488,-1.17814l0,-0.00001l-0.00001,0z"/>
  </svg>
</template>

<script>
export default {
  name: 'CreateForms',
  props: {
    width: {
      default: 24,
      type: Number
    },
    height: {
      default: 24,
      type: Number
    },   
  },
}
</script>


<style scoped lang="scss">
svg {
  fill: #2c3e50;
  stroke-width: 0;
}
</style>
